export enum FaseStep {
    todo = "To Do",
    doing = "Doing",
    done = "Done",
    approved = "Approved"
  }